import { useEffect, useState } from 'react';

const EMPTY = {
  idPersona: 0,
  correo: '',
  esPrincipal: false,
};

export default function Modal({
  open,
  mode = 'new',
  data = null,
  fkValue = 0,   // idPersona que viene del tab padre
  onClose,
  onSubmit,
  inline = false,
}) {
  const [form, setForm] = useState(EMPTY);
  const [errors, setErrors] = useState({
    correo: '',
  });

  const validateField = (field, rawValue) => {
    const value = typeof rawValue === 'string' ? rawValue.trim() : rawValue;
    let error = '';

    switch (field) {
      case 'correo':
        if (!value) {
          error = 'Captura el correo electrónico.';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          error = 'El formato del correo no es válido.';
        }
        break;
      default:
        break;
    }

    setErrors((prev) => ({
      ...prev,
      [field]: error,
    }));

    return !error;
  };

  const validateAll = () => {
    const okCorreo = validateField('correo', form.correo);
    return okCorreo;
  };

  const handleChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
    if (field !== 'esPrincipal') {
      validateField(field, value);
    }
  };

  useEffect(() => {
    if (!open) return;

    if (mode === 'edit' && data) {
      const filled = {
        idCorreo: data.idCorreo ?? 0,
        idPersona: fkValue || data.idPersona || 0,
        correo: data.correo ?? '',
        esPrincipal: !!data.esPrincipal,
      };
      setForm(filled);
      validateField('correo', filled.correo);
    } else {
      setForm({
        ...EMPTY,
        idPersona: fkValue || 0,
      });
      setErrors({ correo: '' });
    }
  }, [mode, data, fkValue, open]);

  const isSaveDisabled =
    !form.correo?.trim() ||
    !!errors.correo;

  const errorStyle = {
    color: '#b91c1c',
    fontSize: '.8rem',
    display: 'block',
    marginTop: '.25rem',
  };

  if (!open) return null;

  const Header = (
    <div
      className="roles-topbar"
      style={{
        marginBottom: '0.6rem',
        paddingRight: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: '0 0 auto',
      }}>
      <h3 className="roles-title" style={{ marginRight: 0 }}>
        {mode === 'new' ? 'Nuevo correo' : 'Editar correo'}
      </h3>
      <button className="roles-btn" onClick={onClose} aria-label="Cerrar">✕</button>
    </div>
  );

  const Body = (
    <div
      style={{
        paddingLeft: '8%',
        paddingRight: '8%',
        display: 'grid',
        gridTemplateColumns: '2fr 1fr',
        gap: '1.5rem',
        alignItems: 'end',
        overflowY: 'auto',
        flex: '1 1 auto',
        minHeight: 0,
      }}>

      {/* Correo - Columna izquierda (más ancha) */}
      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Correo:</label>
        <br /><br />
        <input
          className={`infoField${errors.correo ? ' infoField--error' : ''}`}
          type="email"
          value={form.correo}
          onChange={(e) =>
            handleChange('correo', e.target.value)
          }
          maxLength={150}
        />
        {errors.correo && <small style={errorStyle}>{errors.correo}</small>}
      </div>

      <div style={{ paddingBottom: errors.correo ? '1.5rem' : '0' }}>
        <label className="roles-title" style={{ fontSize: '.95rem', display: 'block', marginBottom: '8px' }}>Principal:</label>
        <div
          onClick={() => handleChange('esPrincipal', !form.esPrincipal)}
          style={{
            width: '38px',
            height: '20px',
            backgroundColor: form.esPrincipal ? '#10b981' : '#cbd5e1',
            borderRadius: '12px',
            position: 'relative',
            cursor: 'pointer',
            transition: 'background-color 0.2s',
            flexShrink: 0,
            margin: '0'
          }}
          title={form.esPrincipal ? "Desactivar principal" : "Marcar como principal"}
        >
          <div style={{
            width: '14px',
            height: '14px',
            backgroundColor: 'white',
            borderRadius: '50%',
            position: 'absolute',
            top: '3px',
            left: form.esPrincipal ? '21px' : '3px',
            transition: 'left 0.2s',
            boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
          }} />
        </div>
      </div>
    </div>
  );

  const Footer = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '.6rem',
        marginTop: '.8rem',
        paddingRight: 16,
        flex: '0 0 auto',
      }}
    >
      <button className="roles-btn" onClick={onClose}>Cancelar</button>
      <button
        className="btn-action"
        onClick={() => {
          if (!validateAll()) return;
          onSubmit(
            {
              ...form,
              idPersona: fkValue || form.idPersona || 0,
            },
            mode
          );
        }
        }
        disabled={isSaveDisabled}
        style={{
          opacity: isSaveDisabled ? 0.5 : 1,
          cursor: isSaveDisabled ? 'not-allowed' : 'pointer',
        }}
      >
        {mode === 'new' ? 'Guardar' : 'Actualizar'}
      </button>
    </div>
  );

  if (inline) {
    return (
      <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        {Header}
        {Body}
        {Footer}
      </div>
    );
  }

  return (
    <div
      className="roles-confirm-overlay"
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,23,42,.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        zIndex: 1000,
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
    >
      <div
        className="roles-confirm-card"
        style={{
          width: 'min(900px, 96vw)',
          maxHeight: '85vh',
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 10px 30px rgba(0,0,0,.25)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {Header}
        {Body}
        {Footer}
      </div>
    </div>
  );
}
